import DraggableImage from './DraggableImage.view';

export default DraggableImage;
